import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { isTokenValid } from '../../utilities/auth';

// Catch-all for unknown URLs (typos, stale bookmarks). An authenticated user is
// sent to the home page; everyone else lands on the login screen. Uses the same
// token validation as ProtectedRoute, so a stale/junk token doesn't count as
// "logged in" here either.
const NotFoundRedirect = () => {
    const reduxToken = useSelector((state) => state.auth.token);
    const token = reduxToken ?? localStorage.getItem("token");

    return <Navigate to={isTokenValid(token) ? "/home" : "/"} replace />;
};

export default NotFoundRedirect;
